import { ResponseDataGet } from "../../../../models/responseDataGet";
import { ResponseDataTest } from "../../../../models/responseDataTest";
import { agroApi } from "../../api";
import { EntInitialFilterName } from "../../../../models/filters/initialFilterName";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { Paths } from "../../../../paths";

interface ProductCategoryRequest {
  id?: number;
  nameKy: string;
  nameRu: string;
  children?: Array<{
    nameKy: string;
    nameRu: string;
  }>;
}

interface ProductCategoryResponse extends EntDirectoryInfoName {
  varieties: never[];
  parent: any;
  children?: Array<{
    id: number;
    nameKy: string;
    nameRu: string;
  }>;
}

export const ProductionCategoryApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductCategoryList: builder.query<ResponseDataGet<ProductCategoryResponse>, EntInitialFilterName>({
      query: (filter) => ({
        url: '/departments/chemicalization/hb-product-category/get-all',
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
    getProductCategoryById: builder.query<ResponseDataTest<ProductCategoryResponse>, number>({
      query: (id) => ({
        url: `/departments/chemicalization/hb-product-category/${id}`,
        method: 'GET'
      })
    }),
    addProductCategory: builder.mutation<ResponseDataTest<ProductCategoryResponse>, ProductCategoryRequest>({
      query: (body) => ({
        url: '/departments/chemicalization/hb-product-category',
        method: "POST",
        body: JSON.stringify(body)
      }),
    }),
    editProductCategory: builder.mutation<ResponseDataTest<ProductCategoryResponse>, ProductCategoryRequest>({
      query: (body) => ({
        url: '/departments/chemicalization/hb-product-category',
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    }),
    deleteProductCategory: builder.mutation<ResponseDataTest<ProductCategoryResponse>, number>({
      query: (id) => ({
        url: `/departments/chemicalization/hb-product-category/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetProductCategoryListQuery,
  useAddProductCategoryMutation,
  useEditProductCategoryMutation,
  useDeleteProductCategoryMutation
} = ProductionCategoryApi;
